import { Children, ComponentPropsWithoutRef } from "react";

import { AiOutlineClose } from "react-icons/ai";

import ModalLayout from "@/components/Layout/ModalLayout";
import { PropsWithRequiredChildren } from "@/types/common";
import { cn } from "@/utils/cn";

interface ModalContentProps extends ComponentPropsWithoutRef<"div"> {}

interface UserModalProps extends PropsWithRequiredChildren {
  onClose: () => void;
}

const Header = ({ children }: PropsWithRequiredChildren) => <>{children}</>;

const Content = ({ children, className }: ModalContentProps) => (
  <div className={cn(className)}>{children}</div>
);

const Footer = ({ children }: PropsWithRequiredChildren) => <>{children}</>;

const UserModal = ({ children, onClose }: UserModalProps) => {
  const [headerChildren, contentChildren, footerChildren] =
    Children.toArray(children);

  return (
    <ModalLayout variant="primary" onClose={onClose}>
      <div className="flex w-[340px] flex-col sm:w-[420px]">
        {/* Header */}
        <div className="flex items-center justify-between border-b border-gray-100 px-6 py-4">
          <h3 className="text-base font-bold text-gray-900">
            {headerChildren}
          </h3>
          <button
            type="button"
            onClick={onClose}
            className="rounded-md p-1 text-gray-400 transition-colors hover:bg-gray-100 hover:text-gray-600"
          >
            <AiOutlineClose size={16} />
          </button>
        </div>

        {/* Body */}
        <div className="px-6 py-5">
          {contentChildren}
        </div>

        {/* Footer */}
        <div className="flex justify-end gap-2 border-t border-gray-100 px-6 py-4">
          {footerChildren}
        </div>
      </div>
    </ModalLayout>
  );
};

UserModal.Header = Header;
UserModal.Content = Content;
UserModal.Footer = Footer;

export default UserModal;
